import api from "@/services/api";
import type {
	CreateVehicleAssignmentRequest,
	VehicleActiveAssignmentResponse,
	VehicleAssignmentsParams,
	VehicleAssignmentsResponse,
} from "../types";

export const getVehicleAssignments = async (
	vehicleId: string,
	params: VehicleAssignmentsParams
): Promise<VehicleAssignmentsResponse> => {
	const { data } = await api.get<VehicleAssignmentsResponse>(
		`/api/vehicleassignments/${vehicleId}`,
		{
			params: {
				PageNumber: params.pageNumber,
				PageSize: params.pageSize,
			},
		}
	);
	return data;
};

export const createVehicleAssignment = async (
	payload: CreateVehicleAssignmentRequest
): Promise<void> => {
	await api.post("/api/vehicleassignments", payload);
};

export const getVehicleActiveAssignment = async (
	vehicleId: string
): Promise<VehicleActiveAssignmentResponse> => {
	const { data } = await api.get<VehicleActiveAssignmentResponse>(
		`/api/vehicleassignments/${vehicleId}/active`
	);
	return data;
};

export const deleteVehicleAssignment = async (
	vehicleAssignmentId: string
): Promise<void> => {
	await api.delete(`/api/vehicleassignments/${vehicleAssignmentId}`);
};
